import { Box, Grid, IconButton, InputAdornment, Typography, useMediaQuery } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { InputSelectFieldGrid, InputTextFieldGrid } from "../../components";
import { confirmAlert, errorAlert } from "../../helpers/alerts";
import { setDenominations, setSegments, setSelectedProduct, setShowDetail, setUpdate } from "../../redux/slices/sale/airTimeSlice";
import xml from "../../helpers/xml";
import { currencyFormatter, hideEmail, randomNumber, validateEmptyFields } from "../../helpers/util";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getBagPDSProductsService, getBagPDSSegmentsService, getBagService } from "../../services/client/bagService";
import Swal from "sweetalert2";
import { setCurrentBag, setPDSProducts, setPDSSegments } from "redux/slices/client/bagSlice";
import { setSession } from "redux/slices/sessionSlice";
import { doStoreSale, sendTiketByEmail } from "services/sale/pdsService";
import { Help, Visibility, VisibilityOff } from "@mui/icons-material";
import { getPDSRuteoProduct } from "services/roteo/routeService";
import Images from "assets/images";
import theme from "config/theme";

const ServicePaymentSaleScreen = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const { bags, updateBalance, sale: salepointId, hoster, hosterOwner } = useSelector(store => store.session);
  const { showDetail, selectedProduct } = useSelector(store => store.airTimeSale);
  const { control, handleSubmit, setValue, watch, reset, setFocus } = useForm();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totals, setTotals] = useState({})
  const [showTotalDetail, setShowTotalDetail] = useState(false)
  const [showInstructions, setShowInstructions] = useState(false)
  const [amounts, setAmounts] = useState(null)
  const { segment, product, amount } = watch();
  const {
    currentBag,
    pdsSegments,
    pdsProducts,
  } = useSelector((store) => store.bags);
  const balance_bag = bags.find(bag => bag.type === 'PDS');
  const showCommissionsPOS = hosterOwner?.showCommissionsPOS || hoster?.showCommissionsPOS;

  useEffect(() => {
    dispatch(setShowDetail(false))
    getBagService(balance_bag.id).then(response => {
      dispatch(setCurrentBag(response))
    }).catch((e) => console.error(e))
    getBagPDSSegmentsService(balance_bag.id).then(list => {
      dispatch(setPDSSegments(list));
    }).catch(error => errorAlert(error))
    dispatch(setSelectedProduct(null));
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let disable = validateEmptyFields(watch(), {});
    setDisabled(disable);
    // eslint-disable-next-line
  }, [watch()]);

  useEffect(() => {
    if (segment) {
      setValue('product', null)
      const selected = pdsSegments.find(({ idSegment }) => segment === idSegment.id);
      dispatch(setSelectedProduct({ image: selected.fd }));
      getBagPDSProductsService(balance_bag.id, segment)
        .then((response) => {
          dispatch(setPDSProducts(response))
          if (response.length === 1)
            setValue('product', response[0].idProduct.id)
        })
        .catch((e) => errorAlert(e))
    }
    // eslint-disable-next-line
  }, [segment]);

  useEffect(() => {
    setValue('amount', '')
    if (product) {
      const selected = pdsProducts.find(({ idProduct }) => product === idProduct.id);
      getPDSRuteoProduct(product).then((response) => {
        setShowInstructions(true)
        dispatch(setSelectedProduct({
          image: selected.fd,
          instructions: selected.idProduct.instructions,
          imageReceipt: selected.idProduct.imageReceipt,
          chargeService: selected.idProduct.chargeService,
          commissionUserMax: selected.idProduct.commissionUserMax,
          commission: selected.commission,
          commissionProvider: response.commissionProvider,
        }));
        if (selected.idProduct.fixedAmount)
          setAmounts(selected.idProduct.amounts)
        else
          setAmounts(null)
      }).catch((e) => errorAlert(e))
    } else {
      dispatch(setSelectedProduct(null));
    }
    // eslint-disable-next-line
  }, [product]);

  useEffect(() => {
    if (amount && selectedProduct) {
      const csMax = parseFloat(selectedProduct.chargeService ? (selectedProduct.commissionUserMax || 0) : 0);
      const csProvider = parseFloat(selectedProduct.commissionProvider || 0);
      const csClient = parseFloat(selectedProduct.commission || 0);
      const csHebe = csMax - (csProvider + csClient)
      const subTotal = parseFloat(amount) + csProvider + csHebe;
      const total = parseFloat(amount) + csMax;
      const profit = selectedProduct.commission;
      setTotals({ subTotal, total, profit })
    } else {
      setTotals({})
    }
  }, [amount]);

  const submit = async ({ segment, product, reference, amount }) => {
    setLoading(true)
    try {
      const selected_segment = pdsSegments.find(({ idSegment }) => idSegment.id === segment);
      const selected_product = pdsProducts.find(({ idProduct }) => idProduct.id === product);
      const selected_amount = amounts ? amounts.find(({ amount: amt }) => amt == amount) : null;
      const externalTrace = randomNumber(100000, 999999);

      const sale = {
        username: currentBag.username,
        password: currentBag.password,
        storeId: currentBag.storeId,
        provider: selected_segment.idSegment.carrierId,
        amount,
        reference,
        productDetail: selected_amount ? selected_amount.sku : selected_product.idProduct.code,
        externalTrace,
        salepointId
      }
      let xmlResponse = await doStoreSale(sale);
      xmlResponse = new xml(xmlResponse)
      const error = xmlResponse.getElementValue("phon:ProviderResponseCode");
      if (error !== '00') {
        let message = xmlResponse.getElementValue("phon:ProviderResponseMessage");
        message = message == 'InsufficientBalance' ? 'No cuenta con suficiente saldo para esta operación' : message;
        errorAlert({ message: message || "Error" })
      } else {
        reset();
        dispatch(setSelectedProduct(null));
        dispatch(setSession({ updateBalance: updateBalance + 1 }));
        confirmAlert({
          icon: "success",
          title: "Pago de Servicios Éxitoso",
          html: `<div id="ticket">
          <h3>Número de autorización ${xmlResponse.getElementValue("phon:AuthCode")}</h3>
          <div>Segmento: ${selected_segment.idSegment.name}</div>
          <div>Servicio: ${selected_product.idProduct.name}</div>
          <div>Referencia: ${sale.reference}</div>
          <div>Importe: ${currencyFormatter.format(sale.amount)}</div>
          ${showCommissionsPOS && selectedProduct.chargeService ? `<div>Cargo por Servicio: ${currencyFormatter.format(selectedProduct?.commissionUserMax || 0)}</div>` : ''}
          <div>Fecha: ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
          </div>`,
          showCancelButton: true,
          showDenyButton: true,
          cancelButtonText: "Cerrar",
          confirmButtonText: "Descargar comprobante",
          denyButtonText: "Enviar por correo electrónico",
          preConfirm: () => {
            return html2canvas(document.querySelector('.swal2-show')).then(
              canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'PNG', 25, 0);
                pdf.save('comprobante.pdf');
              }
            );
          },
          onDenied: () => {
            Swal.fire({
              title: 'Ingresa el correo electrónico',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Enviar',
              showLoaderOnConfirm: true,
              cancelButtonColor: "#ED3726",
              preConfirm: (email) => {
                return sendTiketByEmail(email, {
                  auth: xmlResponse.getElementValue("phon:AuthCode"),
                  segment: selected_segment.idSegment.name,
                  product: selected_product.idProduct.name,
                  reference: sale.reference,
                  amount: sale.amount,
                  date: moment().format('DD/MM/YYYY HH:mm:ss'),
                }).then(() => {
                  confirmAlert({
                    icon: "success",
                    title: "Enviado",
                    text: `Se ha enviado el ticket de la transacción al correo electrónico ${hideEmail(email)}`,
                    showCancelButton: false,
                  })
                }).catch((error) => {
                  Swal.showValidationMessage(error)
                })
              },
              allowOutsideClick: () => !Swal.isLoading()
            })
          }
        })
      }
    } catch (e) {
      console.error(e);
      if (e.code === 501)
        errorAlert({ message: e.message })
      else
        errorAlert({ message: 'Ha ocurrido un error al realizar la recarga, Vuelve a intentarlo y si el error persiste contacta a tu administrador.' })
    } finally {
      setLoading(false)
      dispatch(setUpdate(moment().unix()))
    }
  }

  const handlerSelectFavorite = (product) => {
    setValue('operator', null)
    setTimeout(() => {
      setTimeout(() => {
        setFocus('phone')
      }, 500);
      if (product._id === product)
        return
      dispatch(setSegments([]))
      dispatch(setDenominations([]))
      setValue('segment', product.segment._id)
      setValue('product', product._id)
    }, 100);
  }

  const handlerShowImageReceipt = () => {
    const { imageReceipt } = selectedProduct;
    Swal.fire({
      title: 'Recibo',
      imageUrl: `/v3/file/${imageReceipt}/`,
      imageHeight: 400,
      confirmButtonText: 'Cerrar',
    })
  }

  return (
    <Box mt={2}>
      <Box border={'2px solid ' + theme.secundaryColor} borderRadius={4} padding={4} sx={{
        backgroundImage: `url('${Images.icon.pos_bg}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat-x',
      }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid container item rowSpacing={4} maxWidth={'30vw'} backgroundColor={theme.backgroundColor} my={-4} p={2}>
            <InputSelectFieldGrid
              name={"segment"}
              xs={12}
              control={control}
              required={"Debes seleccionar un segmento"}
              label={"Segmento"}
              data={pdsSegments}
              // size={'large'}
              formatter={(data) =>
                data?.map(({ idSegment }) => ({ id: idSegment.id, name: idSegment.name }))
              }
            />
            <InputSelectFieldGrid
              xs={12}
              control={control}
              name={"product"}
              required={"Debes seleccionar un segmento"}
              label={"Servicio"}
              data={pdsProducts}
              // size={'large'}
              disabled={segment == null}
              formatter={(data) =>
                data?.map(({ idProduct }) => ({ id: idProduct.id, name: idProduct.name }))
              }
            />
            <InputTextFieldGrid
              xs={12}
              name={"reference"}
              disabled={product == null}
              control={control}
              placeholder={"Referencia"}
              rules={{
                required: { value: true, message: "Debes agregar la referencia" },
              }}
              // size={'large'}
              onFocus={() => setShowInstructions(false)}
              sx={{
                backgroundColor: '#FFFFFF',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .MuiInputBase-input': {
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: theme.contrastColor,
                  fontWeight: 'bold',
                  fontSize: '40px',
                  padding: '20px 0px',
                }
              }}
              InputProps={selectedProduct?.imageReceipt && {
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handlerShowImageReceipt}
                      sx={{
                        color: theme.contrastColor
                      }}
                    >
                      <Help sx={{ height: 40, width: 40 }} />
                    </IconButton>
                  </InputAdornment>
              }}
            />
            {
              selectedProduct?.instructions && (
                <Grid item xs={12} pt={1}>
                  <Box sx={{
                    backgroundColor: '#F29496',
                    color: '#FFFFFF',
                    borderRadius: '4px',
                    padding: '10px',
                  }}>{selectedProduct.instructions}</Box>
                </Grid>
              )
            }
            {
              amounts ? (
                <InputSelectFieldGrid
                  control={control}
                  name={"amount"}
                  required={"Debes seleccionar un monto"}
                  label={"Importe"}
                  data={amounts}
                  // size={'large'}
                  disabled={product == null}
                  formatter={(data) =>
                    data?.map((item) => ({ id: item.amount, name: currencyFormatter.format(item.amount) + (item.label ? ` (${item.label})` : '') }))
                  }
                />
              ) : (
                <InputTextFieldGrid
                  xs={12}
                  control={control}
                  disabled={product == null}
                  name={"amount"}
                  placeholder={"Importe"}
                  rules={{
                    required: { value: true, message: "Debes agregar el importe" },
                  }}
                  // size={'large'}
                  inputProps={{ type: 'number' }}
                  inputType={"number"}
                  step={"any"}
                  // disabled={!selectedProduct}
                  onFocus={() => setShowInstructions(false)}
                  sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      textAlign: 'center',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '40px',
                      padding: '20px 0px',
                    }
                  }}
                  InputProps={amount && {
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowTotalDetail(!showTotalDetail)}
                          size="large"
                          sx={{
                            color: theme.contrastColor
                          }}
                        >
                          {showTotalDetail ? <VisibilityOff sx={{ height: 40, width: 40 }} /> : <Visibility sx={{ height: 40, width: 40 }} />}
                        </IconButton>
                      </InputAdornment>
                  }}
                />
              )
            }
            {/* <InputTextFieldGrid
              xs={12}
              control={control}
              disabled={product == null}
              name={"amount"}
              placeholder={"Importe"}
              rules={{
                required: { value: true, message: "Debes agregar el importe" },
              }}
              // size={'large'}
              inputProps={{ type: 'number' }}
              inputType={"number"}
              step={"any"}
              // disabled={!selectedProduct}
              onFocus={() => setShowInstructions(false)}
              sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .MuiInputBase-input': {
                  textAlign: 'center',
                  color: theme.contrastColor,
                  fontWeight: 'bold',
                  fontSize: '40px',
                  padding: '20px 0px',
                }
              }}
              InputProps={amount && {
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowTotalDetail(!showTotalDetail)}
                      size="large"
                      sx={{
                        color: theme.contrastColor
                      }}
                    >
                      {showTotalDetail ? <VisibilityOff sx={{ height: 40, width: 40 }} /> : <Visibility sx={{ height: 40, width: 40 }} />}
                    </IconButton>
                  </InputAdornment>
              }}
            /> */}
            <Grid container item spacing={2} xs={12} justifyContent={'space-between'}>
              {!!selectedProduct?.commissionUserMax && selectedProduct.chargeService &&
                <Grid item xs={12} justifyContent={"end"} display={'flex'}>
                  <Typography fontSize={20} display={"inline"}>
                    Cargo por Servicio:
                  </Typography>
                  <Typography fontSize={20} display={"inline"} width={'30%'} textAlign={"right"}>
                    <span style={{ fontWeight: 'bold' }}> {selectedProduct?.commissionUserMax ? currencyFormatter.format(selectedProduct.commissionUserMax) : ''}</span>
                  </Typography>
                </Grid>}
              {showTotalDetail &&
                <Grid item xs={12} justifyContent={"end"} display={'flex'}>
                  <Typography fontSize={20} display={"inline"}>
                    Importe debitado:
                  </Typography>
                  <Typography fontSize={20} display={"inline"} width={'30%'} textAlign={"right"}>
                    <span style={{ fontWeight: 'bold' }}>
                      {amount ? currencyFormatter.format(totals.subTotal) : ''}
                    </span>
                  </Typography>
                </Grid>
              }
              {showTotalDetail &&
                <Grid item xs={12} justifyContent={"end"} display={'flex'}>
                  <Typography fontSize={20} display={"inline"}>
                    Ganacia de la venta:
                  </Typography>
                  <Typography fontSize={20} display={"inline"} width={'30%'} textAlign={"right"}>
                    <span style={{ fontWeight: 'bold' }}>
                      {amount ? currencyFormatter.format(totals.profit) : ''}
                    </span>
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid item xs={12} sx={{
              borderTop: '1px solid #000',
              marginTop: '20px',
              paddingTop: '20px',
            }}>
              <Typography variant="h4" fontWeight={'bold'} textAlign={'center'}>
                Total {amount ? currencyFormatter.format(totals.total) : ''}
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={12}
              justifyContent={"center"}
            >
              <LoadingButton
                loading={loading}
                sx={{
                  backgroundColor: theme.contrastColor,
                  borderRadius: 25,
                  color: "white",
                  padding: '12px 64px',
                  boxShadow: 'none',
                  fontWeight: "bold",
                  fontSize: '32px',
                  textTransform: 'none',
                  '&:disabled': {
                    color: "white",
                  }
                }}
                onClick={handleSubmit(submit)}
                disabled={disabled}
                variant="contained"
              >
                Recargar
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box >
  );
};

export default ServicePaymentSaleScreen;
